import type { NodeType } from '@tiptap/pm/model'
import type { EditorView } from '@tiptap/pm/view'

import type { AsyncImageAttributes } from '../extensions/image/types.js'
import { findNode, setNodeAttrById } from '../helpers/node.js'

export const reconcileImage = (
  nodeId: string,
  view: EditorView,
  nodeType: NodeType,
  attributes: AsyncImageAttributes,
): Promise<void> => {
  /**
   * Create an image object to prefetch and warm up the browser cache before adding it to the DOM.
   * Prevents the image from flicker when it transitions from loading state.
   */
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = attributes.src
    img.onload = () => {
      try {
        // Copy over the node attributes to the new node while preserving intermediate edits
        const currentImageNode = findNode(
          view.state,
          node => node.attrs.id === nodeId,
        )
        if (currentImageNode) {
          const currentAttributes: AsyncImageAttributes =
            currentImageNode.node.attrs

          setNodeAttrById(
            view,
            nodeType,
            nodeId,
            {
              ...currentAttributes,
              ...attributes,
              loading: false,
              uploadId: undefined,
            },
            false,
          )
        }
        resolve()
      } catch (error) {
        reject()
      }
    }
    img.onerror = () => {
      reject()
    }
  })
}

export const isImage = (file?: File): boolean => {
  return file?.type?.startsWith('image')
}
